import React from 'react';
export const Line = (props) => {
    return(
        <hr style={props.style}/> 
    );
}